import { render } from "./SummaryInfoList.vue?vue&type=template&id=6bc55ee5&scoped=true"
import script from "./SummaryInfoList.vue?vue&type=script&lang=js"
export * from "./SummaryInfoList.vue?vue&type=script&lang=js"

import "./SummaryInfoList.vue?vue&type=style&index=0&id=6bc55ee5&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc55ee5"]])

export default __exports__